<template>
  <span>
    <v-btn v-if="!isLiked"
        class="button ma-2"
        width="160"
        rounded
        outlined
        large
        :disabled="disabledButton"
        @click="toggleFavoriteStatus(jobId, true)"
    >
      <v-icon class="heart">mdi-heart-outline</v-icon>&nbsp;お気に入り
    </v-btn>

    <v-btn v-else
            class="ma-2"
            color="primary"
            width="160"
            rounded
            large
            :disabled="disabledButton"
            @click="toggleFavoriteStatus(jobId, false)">
      <v-icon>mdi-heart</v-icon>&nbsp;お気に入り
    </v-btn>
    <v-dialog :value="showProfileEditDialog" max-width="75%" content-class="profileEditDialog" @click:outside="closeProfileEditDialog">
      <ProfileEditPage :close="closeProfileEditDialog" hideCancel withTerm />
    </v-dialog>
  </span>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import ApiMixin from "../../ApiMixin";
  import ProfileEditPage from "@/components/pages/profile/ProfileEditPage";
  import {mapGetters} from "vuex";

  export default {
    components: {ProfileEditPage},
    props: {
      jobId: {
        type: String,
        required: true
      },
      isLiked: {
        validator: prop => typeof prop === 'boolean' || prop === null,
        required: true
      },
      showStatusChip: Boolean
    },
    mixins: [ComponentMixin, ApiMixin],
    type: "molecule",
    name: "JobFavoriteButton",
    data () {
      return {
        showProfileEditDialog: false,
        disabledButton: false
      }
    },
    computed: {
      ...mapGetters("user", ["user", "userCandidate"])
    },
    methods: {
      toggleFavoriteStatus (jobId, status) {
        if (!this.$auth.isAuthenticated) {
          localStorage.setItem('nishika_redirect', window.location.href)
          this.$auth.loginWithRedirect({
            ui_locales: this.$i18n.locale,
            initialScreen: 'login',
          });
          return;
        }
        if (this.userCandidate === null) {
          this.showProfileEditDialog = true;
          return;
        }
        this.disabledButton = true
        this.toggleLikeJob(jobId, status).finally(() => {
          this.disabledButton = false
        });
        this.isLiked = status
        if(status===true){
          this.gtmDataLayer({
            event: "add_to_cart",
            service: "connect",
            job_id: jobId
          })
        } else {
          this.gtmDataLayer({
            event: "remove_from_cart",
            service: "connect",
            job_id: jobId
          })
        }
      },
      closeProfileEditDialog () {
        this.showProfileEditDialog = false;
      }
    },
  }
</script>

<style scoped>
.button {
  color: black
}
.button:hover{
  transition: all 0.4s;
  color: #2f3e6d;
}

.button:hover .heart {
  transition: all 0.4s;
  transform: rotate(-5deg) scale(1.2);
  color: #2f3e6d
}
</style>
